import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, Phone, MapPin, Instagram } from 'lucide-react';
import { siteConfig } from '../data/mock';
import { WhatsAppButton } from './WhatsAppButton';

export const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const menuItems = [
    { label: 'Início', path: '/' },
    { label: 'Sobre', path: '/sobre' },
    { label: 'Serviços', path: '/servicos' },
    { label: 'Galeria', path: '/galeria' },
    { label: 'Contato', path: '/contato' }
  ];

  return (
    <header className="bg-black text-white sticky top-0 z-40 shadow-lg">
      {/* Top Bar */}
      <div className="bg-[#2C2C2C] border-b border-gray-800">
        <div className="container mx-auto px-4 py-2">
          <div className="flex flex-wrap items-center justify-between text-sm">
            <div className="flex items-center gap-4">
              <a 
                href={`tel:+${siteConfig.phone}`}
                className="flex items-center gap-2 hover:text-[#00B4D8] transition-colors"
              >
                <Phone className="w-4 h-4" />
                <span className="hidden sm:inline">(62) 98241-6008</span>
              </a>
              <a 
                href={siteConfig.googleMaps}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 hover:text-[#00B4D8] transition-colors"
              >
                <MapPin className="w-4 h-4" />
                <span className="hidden md:inline">Jardim Bela Vista, Goiânia</span>
              </a>
            </div>
            <div className="flex items-center gap-3">
              <a 
                href={siteConfig.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[#00B4D8] transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <WhatsAppButton 
                text="Agendar Agora" 
                className="hidden md:inline-flex text-sm px-4 py-2"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Main Header */}
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between py-4">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img 
              src={siteConfig.logo} 
              alt="Box7go Logo" 
              className="h-12 md:h-16 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8">
            {menuItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className="text-white hover:text-[#00B4D8] font-medium transition-colors duration-300"
              >
                {item.label}
              </Link>
            ))}
            <WhatsAppButton 
              text="Agendar" 
              className="text-sm px-6 py-2.5"
              messageType="booking"
            />
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden text-white hover:text-[#00B4D8] transition-colors"
            aria-label="Toggle menu"
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <nav className="lg:hidden pb-4 border-t border-gray-800 mt-2">
            <div className="flex flex-col gap-3 pt-4">
              {menuItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={() => setMobileMenuOpen(false)}
                  className="text-white hover:text-[#00B4D8] font-medium py-2 transition-colors duration-300"
                >
                  {item.label}
                </Link>
              ))}
              <WhatsAppButton text="Agendar no WhatsApp" className="mt-2" />
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};
